// Mock data for Video Vault

export const mockDownloadResponse = {
  success: true,
  videoTitle: "Video de ejemplo",
  thumbnail: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=400",
  formats: [
    { quality: "1080p", size: "45 MB", format: "mp4" },
    { quality: "720p", size: "28 MB", format: "mp4" },
    { quality: "480p", size: "15 MB", format: "mp4" },
  ]
};

export const faqData = [
  {
    id: 1,
    question: "¿Qué tipo de videos se pueden descargar?",
    answer: "Solo podemos procesar videos públicos accesibles mediante un enlace público. Si el contenido es privado o restringido por región/edad, podría no estar disponible."
  },
  {
    id: 2,
    question: "¿Necesito iniciar sesión o instalar algo?",
    answer: "No. Video Vault funciona desde el navegador, sin cuentas ni extensiones obligatorias."
  },
  {
    id: 3,
    question: "¿Cómo copio el enlace correcto desde Instagram y Facebook?",
    answer: "Buscá la opción Compartir en la publicación y copiá el enlace. En algunos casos también funciona el enlace abreviado, pero recomendamos el enlace completo."
  },
  {
    id: 4,
    question: "Pegé el enlace, pero no funciona. ¿Qué hago?",
    answer: "Probá esto: Confirmá que el video sea público. Revisá que el enlace esté completo. Intentá de nuevo más tarde (a veces Facebook cambia temporalmente el acceso). Probá con otro navegador."
  },
  {
    id: 5,
    question: "¿Por qué a veces se reproduce el video en lugar de descargarse?",
    answer: "Algunos navegadores abren el archivo como reproducción. Podés: Usar la opción del reproductor para guardar/descargar si está disponible. Mantener presionado (en móvil) y elegir 'Descargar' cuando aparezca. Probar una calidad diferente si se ofrece."
  },
  {
    id: 6,
    question: "¿Qué pasa si el video sale sin audio o con audio diferente?",
    answer: "Dependiendo de cómo esté publicado el video y del formato disponible, algunas opciones pueden variar. Probá otra calidad/formato. Si el problema persiste, puede ser una limitación del video original."
  },
  {
    id: 7,
    question: "¿Dónde se guardan las descargas?",
    answer: "Normalmente en la carpeta Descargas de tu navegador/dispositivo. En iPhone/iPad suele guardarse en Archivos (según configuración)."
  },
  {
    id: 8,
    question: "¿Puedo descargar Reels?",
    answer: "Sí. Podés pegar el enlace completo de un Reel público de Instagram o Facebook. El contenido privado o que exige iniciar sesión no se puede procesar."
  },
  {
    id: 9,
    question: "¿Guardan mi historial de enlaces o descargas?",
    answer: "No guardamos tu historial personal en nuestros servidores. El navegador puede conservar localmente las últimas descargas en este dispositivo, y podés borrarlas desde la misma interfaz. También podemos conservar registros técnicos mínimos para seguridad y rendimiento (ver Privacy Policy)."
  },
  {
    id: 10,
    question: "¿Es legal descargar videos?",
    answer: "Depende del uso y de los derechos sobre el contenido. Recomendamos descargar solo contenido propio o con permiso y respetar derechos de autor y términos de la plataforma."
  }
];

export const troubleshootingData = [
  "Confirmá que el video sea público y el enlace esté completo",
  "Probá con otro navegador si el actual no funciona",
  "Si el video se reproduce en lugar de descargarse, mantené presionado y elegí 'Descargar'",
  "Algunas calidades pueden no incluir audio, probá otra opción",
  "Intentá de nuevo más tarde si hay problemas temporales con la plataforma"
];

export const updatesData = [
  { date: "Julio 2026", update: "Soporte para publicaciones y Reels públicos de Instagram" },
  { date: "Marzo 2026", update: "Nuevo historial local en el navegador para consultar los ultimos videos procesados" },
  { date: "Marzo 2026", update: "El historial ahora se guarda al tocar el boton principal de descarga" },
  { date: "Diciembre 2025", update: "Mejora de compatibilidad con enlaces compartidos de Facebook" },
  { date: "Noviembre 2025", update: "Optimización para descarga de Reels públicos" },
  { date: "Octubre 2025", update: "Soporte mejorado para múltiples calidades de video" },
  { date: "Septiembre 2025", update: "Actualización de guías para dispositivos iOS" },
  { date: "Agosto 2025", update: "Mejora en detección automática de formatos disponibles" },
  { date: "Julio 2025", update: "Implementación de sistema de caché para mejor rendimiento" }
];
